import React, { useCallback, useState } from "react";
// import { Range } from 'rc-slider';
import debounce from 'lodash/debounce';

import { ActivityActive, ActivityInactive, } from '../../../../../Common/Buttons/Icons';
import Stars from "../../../../../Common/Stars";
import { Input } from "../../../../../Common/DesignSystem/Input";
import { INITIAL_SEARCH_FILTERS } from "./useVehicles";

export const useVehicleFilters = ({ searchFilters, setSearchFilters, vehicleFiltersData }) => {
	const [openedFilterDropdowns, setOpenedFilterDropdowns] = useState({});
	const [mileageDisplayValue, setMileageDisplayValue] = useState({ min: '', max: '' });

	const resetFilters = () => {
		setSearchFilters(INITIAL_SEARCH_FILTERS);
		setOpenedFilterDropdowns({});
		setMileageDisplayValue({ min: '', max: '' });
	};

	const dropdownFilters = [
		{
			filter: 'makes',
			title: 'Make',
			shouldShowDropdown: Boolean(vehicleFiltersData?.makes?.length),
			children: vehicleFiltersData?.makes?.map((make) => (
				<li style={{width: 'auto'}} key={make}>
					<label className="has-icon float-left">
						<input type="checkbox" checked={searchFilters?.makes.find((item) => item === make)} onChange={() => {updateCheckBox('makes', make)}} />
						<span className="checkmark"></span>
						<span style={{ overflow:'hidden', whiteSpace:'nowrap', width:'132px', textOverflow:'ellipsis' }} >
							{make}
						</span>
					</label>
				</li>
			))
		},
		{
			filter: 'year',
			title: 'Year',
			shouldShowDropdown: Boolean(vehicleFiltersData?.years?.length),
			children: vehicleFiltersData?.years?.map((year) => (
				<li key={year}>
					<label className="has-icon">
						<input type="checkbox" checked={searchFilters?.year.find((item) => item === year)} onClick={() => updateCheckBox('year', year)}/>
						<span className="checkmark"></span>
						{year}
					</label>
				</li>
			)),
		},
		{
			filter: 'mileage',
			title: 'Mileage',
			shouldShowDropdown: Boolean(vehicleFiltersData?.mileage),
			children: (
				<li className="filter-slider">
					{/* <p>{searchFilters?.mileage?.min} - {searchFilters?.mileage?.max}{searchFilters?.mileage?.max === 10000 ? <span>+</span> : null} KM</p> */}
					{/* <Range allowCross={false} min={0} max={10000} defaultValue={[0, 10000]} value={[searchFilters?.mileage?.min, searchFilters?.mileage?.max]} onChange={(e) => updateRange(e, 'mileage')} /> */}
					<Input
						label="Min Mileage"
						value={isNaN(mileageDisplayValue?.min) ? '' : mileageDisplayValue.min}
						onChange={(e) => updateInputRange(e, 'mileage', 'min')}
						containerStyle={{maxWidth: '93%'}}
						trailing_ic="KM"
                        trailing_ic_rawText
					/>
					<Input
						label="Max Mileage"
						value={isNaN(mileageDisplayValue?.max) ? '' : mileageDisplayValue.max}
						onChange={(e) => updateInputRange(e, 'mileage', 'max')}
						containerStyle={{maxWidth: '93%'}}
						trailing_ic="KM"
                        trailing_ic_rawText
					/>
				</li>
			),
		},
		{
			filter: 'tiers',
			title: 'Tier',
			shouldShowDropdown: Boolean(vehicleFiltersData?.tiers?.length),
			children: [5, 4, 3, 2, 1, 6].map((tier) => (
				<li key={tier}>
					<label className="has-icon">
						<input type="checkbox" checked={searchFilters?.tiers.find((item) => item === tier)} onClick={() => updateCheckBox('tiers', tier)}/>
						<span className="checkmark"></span>
						<Stars star={tier} type={"Vehicle"} ID={tier} key={tier} />
					</label>
				</li>
			)),
		},
		{
			filter: 'status',
			title: 'Status',
			shouldShowDropdown: Boolean(vehicleFiltersData?.status?.length),
			children: vehicleFiltersData?.status?.map((status) => (
				<li key={status} className="filter-slider">
					<label className="has-icon">
						<input type="checkbox" checked={searchFilters?.status.find((item) => item === status)} onClick={() => updateCheckBox('status', status)}/>
						<span className="checkmark"></span>
						<span className="mr-4 mt-8">
							{status === 'active' && ActivityActive()}
							{status === 'inactive' && ActivityInactive()}
						</span>
						{status}
					</label>
				</li>
			)),
		}
	];

	const toggleFilterDropdown = (filter) => {
		setOpenedFilterDropdowns(currentOpenedFilters => ({
			...currentOpenedFilters,
			[filter]: !currentOpenedFilters[filter]
		}))
	}

	const updateCheckBox = (category, check) => {
		const filters = {...searchFilters};

		if (filters[category] && !filters[category].length) {
			filters[category] = [];
		}

		if (filters[category].find((item) => item === check)) {
			filters[category] = [...new Set(filters[category].filter((item) => item !== check))];
		} else {
			filters[category].push(check);
		}

		if (category == 'status' && filters[category].length > 1) {
			filters[category] = [...new Set(filters[category].filter((item) => item === check))];
		}

		setSearchFilters(filters);
	}

	const shouldToggleFilter = (filter) =>
		!Boolean(searchFilters[filter].length);

	const updateRange = (e, filter) => {
		setSearchFilters(currentFilters => ({
			...currentFilters,
			[filter]: {
				min: e[0],
				max: e[1],
			}
		}));
	};

	const updateInputRange = (e, filter, kind) => {
		const value = parseInt(e.target.value);

        setMileageDisplayValue(currentState => ({
			...currentState,
			[kind]: value,
		}));

        debouncedUpdateNumericInputField(value, filter, kind, setMileageDisplayValue);
	}

	const updateNumericInputField = (value, filter, kind, setDisplayValue) => {
		setSearchFilters(currentFilters => {
			const newSearchFilters = {
				...currentFilters,
				[filter]: {
					...currentFilters[filter],
					[kind]: value,
				}
			};

			// if non numeric value, remove the filter
			if (isNaN(value)) {
				setDisplayValue(currentState => ({
					...currentState,
					[kind]: '',
				}));

				delete newSearchFilters[filter][kind]
			}

			return newSearchFilters;
		});
	}

    const debouncedUpdateNumericInputField = useCallback(debounce(updateNumericInputField, 800), []);

	return {
		openedFilterDropdowns,
		toggleFilterDropdown,
		updateCheckBox,
		shouldToggleFilter,
		updateRange,
		dropdownFilters,
		resetFilters,
	};
}